import { spotifyFormatUrl } from './spotify-format-url';

export const createSpotifyIframe = (url: string): string => {
  const src = spotifyFormatUrl(url);
  return `<iframe style="border-radius:8px;" src="${src}" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>`;
};
